import React from 'react'
import Image from './Image'
import Container from './Container'
const MiddalAds = () => {
  return (
    <div className='mt-5 md:mt-28'>
        <Container>
            <Image imgsrc="assets/images/MiddalAds.png"/>
        </Container>
    </div>
  )
}

export default MiddalAds